import PropTypes from "prop-types";
import { RouteName } from "../../../constants/Constants";

const RouteErrorFallback = ({ error, resetErrorBoundary }) => {
    const handleGoHome = () => {
        window.location.href = RouteName.SESSIONS;
    };

    return (
        <div className="error-fallback-page">
            <div className="error-fallback-content">
                <div className="error-fallback-icon">
                    <i className="icon-warning"></i>
                </div>
                <h2 className="error-fallback-title">
                    This page encountered an error
                </h2>
                <p className="error-fallback-subtitle">
                    You can try again or navigate to a different page.
                </p>
                <div className="error-fallback-actions">
                    {resetErrorBoundary && (
                        <button className="btn btn-primary" onClick={resetErrorBoundary}>
                            Try Again
                        </button>
                    )}
                    <button className="btn btn-outline-secondary" onClick={handleGoHome}>
                        Go to Home
                    </button>
                </div>
                {process.env.NODE_ENV === "development" && error && (
                    <details className="error-fallback-details">
                        <summary>Error Details</summary>
                        <pre>
                            {error.message || String(error)}
                            {error.stack && `\n\n${error.stack}`}
                        </pre>
                    </details>
                )}
            </div>
        </div>
    );
};

RouteErrorFallback.propTypes = {
    error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    resetErrorBoundary: PropTypes.func,
};

export default RouteErrorFallback;
